import React, { Component } from 'react';
import { ref } from '../utils/firebase';
import { Navbar } from 'react-bootstrap';
import { uid } from '../utils/firebase.js';
import NavHeader from './Navbar/NavHeader.js';
import NavContent from './Navbar/NavContent.js';
import NavSignedIn from './Navbar/NavSignedIn.js';
import logo from '../images/logo.png';

class SignedInNav extends Component {
  constructor() {
    super();
    this.state = {
      name: "Loading...",
      photoURL: logo
    };
  }

  componentDidMount() {
    const user = ref.child(`users/${uid}/info`);
    user.on('value', snap => {
      this.setState({
        name: snap.val().displayName,
        photoURL: snap.val().photoURL
      });
    });
  }

  render() {
    return (
      <Navbar staticTop collapseOnSelect>
        <NavHeader />
        <NavContent right={<NavSignedIn photoURL={this.state.photoURL} name={this.state.name} />} />
      </Navbar>
    );
  }

}

export default SignedInNav;



// WEBPACK FOOTER //
// ./src/components/SignedInNav.js